import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../images/circle-info-regular-full.svg'
import styles from './styles.module.css'

export default function PeopleDataSeen ({
  localPeopleData,
  setLocalPeopleData
}) {
  // Today’s date in YYYY-MM-DD, to cap the picker
  const today = new Date()
  const maxDate = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`

  // Handlers update people.dateRange.startDate / endDate
  const handleStartDateChange = e => {
    const startDate = e.target.value
    setLocalPeopleData(prev => ({
      ...prev,
      dateRange: {
        ...prev.dateRange,
        startDate
      }
    }))
  }

  const handleEndDateChange = e => {
    const endDate = e.target.value
    setLocalPeopleData(prev => ({
      ...prev,
      dateRange: {
        ...prev.dateRange,
        endDate
      }
    }))
  }

  return (
    <section className={styles.RecentStatusDateContainer}>
      <div className={styles.sectionTitleWithIcon}>
        <h1 className={styles.RecentStatusDateTitle}>Date Seen</h1>
        <Tooltip
          title='Filter by when the people record was first seen. Set a start and/or end date.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '.MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Date Seen help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <div className={styles.RecentStatusDateInputContainer}>
        <input
          className={styles.RecentStatusDateInput}
          type='date'
          name='startDate'
          max={maxDate}
          value={localPeopleData?.dateRange?.startDate}
          onChange={handleStartDateChange}
          required
        />
        <span className={styles.RecentStatusDateLabel}>to</span>
        <input
          className={styles.RecentStatusDateInput}
          type='date'
          name='endDate'
          max={maxDate}
          value={localPeopleData?.dateRange?.endDate}
          onChange={handleEndDateChange}
          required
        />
      </div>
    </section>
  )
}
